<template>
  <!-- 我的关注 -->
  <div class="inbox follows">
    <div class="top_center">
      <div class="follow flex">
        <div class="follow_left_center">
          <div class="follow_left baff ru5">
            <div
              class="cursor addfoll ru5 coff ba6e center"
              @click="dialogVisible = true"
            >
              新建分组 +
            </div>
            <div class="foll_name">
              <div class="foll_center flex">
                <!-- <el-input placeholder="输入分组名" v-model="follname" maxlength="15"></el-input> -->
                <el-input
                  placeholder="输入分组名"
                  maxlength="15"
                  v-model="follname"
                >
                </el-input>
                <div class="cursor" @click="fuzzyQuery">
                  <i slot="prefix" style="display: flex; align-items: center">
                    <img
                      style="width: 16px; height: 16px"
                      src="../../assets/img/foll/search.png"
                      alt
                    />
                  </i>
                </div>
              </div>
            </div>
            <div class="foll_list">
              <div class="foll_list_top" :class="liststuts ? 'list_top2' : ''">
                <div
                  class="list_conent ru5 cursor"
                  v-for="(item, index) in follList"
                  :key="index"
                  :class="foolcen == index ? 'conentcor' : ''"
                  @click="conclick(item, index)"
                >
                  <div class="list_conent_top flex">
                    <div class="font_bo titles">
                      <p v-if="item.isname">{{ item.groupName }}</p>
                      <p v-else>
                        <el-input
                          maxlength="15"
                          show-word-limit
                          @blur="changename(item)"
                          oninput="value=value.replace(/[^\u4E00-\u9FA5A-Za-z0-9、]/g,'')"
                          v-model="isgroupName"
                        >
                        </el-input>
                      </p>
                    </div>
                    <div class="list_conent_top_img">
                      <i
                        class="el-icon-edit iconimg"
                        @click="nameclick(item)"
                      ></i>
                      <i
                        class="el-icon-delete iconimg icondelete"
                        @click="delfolls(item.id)"
                      ></i>
                      <!-- <img class="cursor" v-if="item.groupCode !== 'concern001' && item.groupCode !== 'cooperate001'"
                        src="@/assets/img/foll/cg.png" alt="" @click="nameclick(item)">
                      <img class="cursor" v-if="item.groupCode !== 'cooperate001' && item.groupCode !== 'concern001'"
                        src="@/assets/img/foll/lsh.png" alt="" @click="delfolls(item.id)"> -->
                    </div>
                  </div>
                  <div class="mannum font_bo" :class="ast[index % 10]">
                    {{ item.personNum }} 人
                  </div>
                  <div class="head_img">
                    <img
                      v-for="(item, index6) in item.headSrcs"
                      :key="index6"
                      :src="item"
                      alt=""
                    />
                  </div>
                </div>
                <div v-if="!follList.length" class="zufz ru5">暂无分组</div>
              </div>
              <!-- <div class="more" v-if="follList.length>4">
              <div class="sz12 coff ba6e ru5 center cursor" @click="liststuts = true">
                更多
              </div>
            </div> -->
            </div>
          </div>
        </div>
        <div class="conter_content">
          <!-- <div class="title_top flex">
            <div class="title flex">
              <div class="flex alcen mr40">
                <p class="input_tt mr10 sz14 tel">联盟客姓名</p>
                <div class="title_input">
                  <el-input v-model="name" style="height:100%" placeholder="联盟客姓名">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                  </el-input>
                </div>
              </div>
              <div class="flex alcen mr40">
                <p class="input_t2 mr10 sz14 tel">国家 / 地区</p>
                <div class="title_scslt borderrig">
                  <el-select v-model="country" clearable placeholder="国家地区" @clear="delValue">
                    <el-option v-for="item in countryList" :key="item.code" :label="item.value" :value="item.code">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="flex alcen mr40">
                <p class="input_tt mr10 sz14 ter">类别</p>
                <div class="title_scslt">
                  <el-select v-model="industrys" clearable placeholder="类别" @clear="delValue">
                    <el-option v-for="item in smallIndustry" :key="item.smallIndustryCode" :label="item.smallIndustryName"
                      :value="item.smallIndustryCode"></el-option>
                  
                  </el-select>
                </div>
              </div>
              <div class="flex alcen mr40">
                <p class="input_tt mr10 sz14 ter">是否联系</p>
                <div class="title_scslt">
                  <el-select v-model="isContact" clearable placeholder="是否联系" @clear="delValue">
                    <el-option label="否" :value="0"></el-option>
                    <el-option label="是" :value="1"></el-option>
                  </el-select>
                </div>
              </div>


            </div>
          </div>
          <div class="title_top pd23 flex">
            <div class="title flex">
              <div class="flex alcen mr40">
                <p class="input_ttw mr10 sz14 tel">是否合作</p>
                <div class="title_input">
                  <el-select v-model="isCooperate" clearable placeholder="是否合作" @clear="delValue">
                    <el-option label="否" :value="0"></el-option>
                    <el-option label="是" :value="1"></el-option>
                  </el-select>
                </div>
              </div>
              <div class="flex alcen tel">
                <p class="input_t2 mr10 sz14"><img src="@/assets/img/emil/rl.png" alt=""></p>
                <div class="title_ks">
                  <div class="block">
                    <el-date-picker v-model="values" type="daterange" range-separator="至" start-placeholder="初始日期"
                      end-placeholder="结束日期" @change="startDa">
                    </el-date-picker>
                  </div>
                </div>
              </div>
            </div>
            <div class="title_qu">
              <div class="title_query ba6e coff center ru5 cursor" @click="searchs">查询</div>
            </div>
          </div> -->
          <!-- 改造 -->
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="grid-content">
                <div class="operatebox">
                  <span class="lable sz14">联盟客姓名</span>
                  <div class="spcilbox">
                    <el-input v-model="name" placeholder="联盟客姓名">
                      <i
                        slot="prefix"
                        class="el-input__icon el-icon-search"
                      ></i>
                    </el-input>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <div class="operatebox">
                  <span class="lable sz14">国家 / 地区</span>
                  <div class="value">
                    <el-select
                      v-model="country"
                      clearable
                      placeholder="国家地区"
                      @clear="delValue"
                    >
                      <el-option
                        v-for="item in countryList"
                        :key="item.code"
                        :label="item.value"
                        :value="item.code"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <div class="operatebox">
                  <span class="lable sz14">类别</span>
                  <div class="value">
                    <el-select
                      v-model="industrys"
                      clearable
                      placeholder="类别"
                      @clear="delValue"
                    >
                      <el-option
                        v-for="item in smallIndustry"
                        :key="item.smallIndustryCode"
                        :label="item.smallIndustryName"
                        :value="item.smallIndustryCode"
                      ></el-option>
                      <!-- <el-option v-for="(item,index4) in smallIndustry" :key="index4" :label="item.smallIndustryName" :value="item.smallIndustryCode"></el-option> -->
                    </el-select>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <div class="operatebox">
                  <span class="lable sz14">是否联系</span>
                  <div class="value">
                    <el-select
                      v-model="isContact"
                      clearable
                      placeholder="是否联系"
                      @clear="delValue"
                    >
                      <el-option label="否" :value="0"></el-option>
                      <el-option label="是" :value="1"></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <div class="operatebox">
                  <span class="lable sz14">是否合作</span>
                  <div class="value">
                    <el-select
                      v-model="isCooperate"
                      clearable
                      placeholder="是否合作"
                      @clear="delValue"
                    >
                      <el-option label="否" :value="0"></el-option>
                      <el-option label="是" :value="1"></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple">
                <div class="operatebox">
                  <span class="lable sz14"
                    ><img src="@/assets/img/emil/rl.png" alt=""
                  /></span>
                  <div class="value">
                    <div class="block">
                      <el-date-picker
                        v-model="values"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="初始日期"
                        end-placeholder="结束日期"
                        @change="startDa"
                      >
                      </el-date-picker>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <div class="operatebox">
                  <div class="btn ba6e coff center ru5 cursor" @click="searchs">
                    查询
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>

          <div class="list_top baff flex ru5">
            <div class="list_top1 flex">
              <p @click="chooseAllCart">
                <input type="checkbox" :checked="chooseAll" name id />
              </p>
              <span>单页全选 / 取消</span
              ><span style="color: #be3c6e"
                >已选 {{ choosedAllIdList.length }} 条</span
              >
              <el-button
                type="default"
                style="height: 30px; width: 70px; padding: 0; margin-left: 10px"
                @click="resetChoosed"
                >重置</el-button
              >
            </div>
            <div class="list_top2">
              {{ titname }}
            </div>
            <div class="list_top3">
              <p>
                <span @click="delfoll" class="cursor span1"
                  ><i class="el-icon-delete co6e"></i> 删除</span
                >
                <img src="@/assets/img/foll/pl.png" alt="" />
                <span class="cursor" @click="batch">批量发送</span>
              </p>
            </div>
          </div>
          <div
            class="list flex"
            v-for="(item, index1) in detailList"
            :key="index1"
          >
            <div class="list_input flex">
              <input
                type="checkbox"
                :checked="item.choose"
                @click="chooseOne(index1, item)"
                name
                id
              />
            </div>
            <div class="name">
              <div class="name_heder cursor ru50" @click="godetil(item)">
                <div class="hotbq sz30 co6e font_a" v-if="item.tagNew">
                  NEW!
                </div>
                <div class="hotbq sz30 co6e font_a" v-else-if="item.tagHot">
                  HOT!
                </div>
                <div class="hotbq sz30 co6e font_a" v-else-if="item.tagActive">
                  ACTIVE!
                </div>
                <img class="ru50" :src="item.headSrc" alt="" />
                <!-- <P v-if="item.isContact == 1" class="center coff">
                  已联系
                </P> -->
              </div>
            </div>
            <div class="category">
              <div class="mb8 platform_d">
                <p class="category_name">
                  <span class="font_bo">{{ item.name }}</span>
                  <span class="sz12">{{ item.countryName }}</span>
                </p>
                <!-- <p class="category_tt">{{item.countryName}}</p> -->
              </div>
              <!-- <div class="flex mb8 platform_d">
                <p class="sz14 titnames">国家/地区</p>
                <p class="sz12">{{item.countryName}}</p>
              </div> -->
              <div class="platform_d mb8">
                <p class="category_tt sz14">类别</p>
                <div v-if="item.types" class="foll_title">
                  <div class="foll_tt_top">
                    <p
                      class="foll_tt ba168 center ru5 sz12"
                      v-for="(ittr, index28) in item.types"
                      :key="index28"
                      v-show="index28 < 2"
                    >
                      {{ ittr }}
                    </p>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="right"
                      v-if="item.types.length > 2"
                    >
                      <div slot="content" class="foll_tt_d flex">
                        <p
                          class="mb8 mr10 coff"
                          v-for="(ittr, index29) in item.types"
                          :key="index29"
                        >
                          {{ ittr }}
                        </p>
                      </div>
                      <p
                        class="cursor"
                        style="width: 20px"
                        v-show="item.types.length > 2"
                      >
                        ...
                      </p>
                    </el-tooltip>
                  </div>
                </div>
              </div>

              <div class="platform_d mb8">
                <p class="category_tt sz14">联盟客类型</p>
                <div v-if="item.promoType" class="foll_title">
                  <div class="foll_tt_top">
                    <p
                      class="foll_tt ba168 center ru5 sz12"
                      v-for="(ittr, index26) in item.promoType"
                      :key="index26"
                      v-show="index26 < 2"
                    >
                      {{ ittr }}
                    </p>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="right"
                      v-if="item.promoType.length > 2"
                    >
                      <div slot="content" class="foll_tt_d flex">
                        <p
                          class="mb8 mr10 coff"
                          v-for="(ittr, index27) in item.promoType"
                          :key="index27"
                        >
                          {{ ittr }}
                        </p>
                      </div>
                      <p
                        class="cursor"
                        style="width: 20px"
                        v-show="item.promoType.length > 2"
                      >
                        ...
                      </p>
                    </el-tooltip>
                  </div>
                </div>
              </div>
              <div class="flex platform_d">
                <p class="sz14 category_tt">合作品牌</p>
                <div v-if="item.brands" class="foll_title">
                  <p
                    class="foll_tt ttres ba168 center ru5 sz12"
                    v-for="(ittr, index24) in item.brands"
                    :key="index24"
                    v-show="index24 < 2"
                  >
                    {{ ittr }}
                  </p>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    placement="right"
                    v-if="item.brands.length > 2"
                  >
                    <div slot="content" class="foll_tt_d flex">
                      <p
                        class="mb8 mr10 coff"
                        v-for="(ittr, index25) in item.brands"
                        :key="index25"
                      >
                        {{ ittr }}
                      </p>
                    </div>
                    <p
                      class="cursor"
                      style="width: 20px"
                      v-show="item.brands.length > 2"
                    >
                      ...
                    </p>
                  </el-tooltip>
                </div>
              </div>
            </div>
            <div class="platform">
              <p class="category_tt co6e mb10 H22">
                <span v-if="item.isContact == 1">已联系</span>
              </p>
              <div class="category_tt mb10 h25">
                <p class="sz14 titnames">关注时间</p>
                <p class="sz12">{{ item.createTime }}</p>
              </div>
              <div v-if="item.myGroupNames" class="foll_title">
                <p
                  class="foll_tt ttres ba169 center ru5 sz12"
                  v-for="(ittr, index24) in item.myGroupNames"
                  :key="index24"
                  v-show="index24 < 2"
                >
                  {{ ittr }}
                </p>
                <el-tooltip
                  class="item"
                  effect="dark"
                  placement="right"
                  v-if="item.myGroupNames.length > 2"
                >
                  <div slot="content" class="foll_tt_d flex">
                    <p
                      class="mb8 mr10 coff"
                      v-for="(ittr, index25) in item.myGroupNames"
                      :key="index25"
                    >
                      {{ ittr }}
                    </p>
                  </div>
                  <p
                    class="cursor"
                    style="width: 20px"
                    v-show="item.myGroupNames.length > 2"
                  >
                    ...
                  </p>
                </el-tooltip>
              </div>
              <div class="platform_list flex"></div>
            </div>
            <div class="send">
              <div class="send_img mb20">
                <div>
                  <el-tooltip
                    v-if="item.isConcern == 1"
                    class="item cursor"
                    effect="dark"
                    content="取消关注"
                    placement="top"
                  >
                    <img
                      class="cursor"
                      src="@/assets/img/foll/love.png"
                      alt=""
                      @click="delConcern(item)"
                    />
                  </el-tooltip>
                  <el-tooltip
                    v-else
                    class="item cursor"
                    effect="dark"
                    content="关注"
                    placement="top"
                  >
                    <img
                      src="@/assets/img/foll/love2new.png"
                      alt=""
                      @click="addConcern(item)"
                    />
                  </el-tooltip>
                  <el-tooltip
                    v-if="item.isCooperate == 1"
                    class="item cursor"
                    effect="dark"
                    content="移除合作分组"
                    placement="top"
                  >
                    <img
                      src="@/assets/img/foll/ws2new.png"
                      class="cursor"
                      alt=""
                      @click="delCooperate(item)"
                    />
                  </el-tooltip>
                  <el-tooltip
                    v-else
                    class="item cursor"
                    effect="dark"
                    content="加入合作分组"
                    placement="top"
                  >
                    <img
                      src="@/assets/img/foll/wsnew.png"
                      class="cursor"
                      alt=""
                      @click="addCooperate(item)"
                    />
                  </el-tooltip>
                </div>
              </div>
              <div class="send_img">
                <el-tooltip
                  v-if="item.hasEmail == 1"
                  class="item cursor"
                  effect="dark"
                  content="发送邮件"
                  placement="bottom"
                >
                  <img
                    class="send_img_img cursor"
                    src="@/assets/img/foll/emlnew.png"
                    alt=""
                    @click="sendOut(item)"
                  />
                </el-tooltip>
                <el-tooltip
                  v-else
                  class="item cursor"
                  effect="dark"
                  content="暂无邮箱，更新中"
                  placement="bottom"
                >
                  <img
                    class="send_img_img"
                    src="@/assets/img/foll/eml1new.png"
                    alt=""
                  />
                </el-tooltip>
                <el-tooltip
                  class="item cursor"
                  effect="dark"
                  content="选择分组"
                  placement="bottom"
                >
                  <img
                    src="@/assets/img/foll/gdnew.png"
                    class="cursor"
                    alt=""
                    @click="addflows(item)"
                  />
                </el-tooltip>
              </div>
            </div>
            <el-dialog
              title=""
              :visible.sync="dialogaddfoll"
              width="25%"
              :show-close="false"
              :modal="false"
            >
              <div>
                <div class="addfo" v-if="follListTwo.length">
                  <div class="sz18 co00 font_bo nametit">
                    为 {{ lmkname }} 选择分组
                  </div>
                  <div class="naelist_top flex">
                    <div
                      class="namelist flex"
                      v-for="(ites, index7) in follListTwo"
                      :key="index7"
                    >
                      <!-- <input type="checkbox" v-if="ites.groupCode !== 'concern001' && ites.groupCode !== 'cooperate001' && ites.id!== follid " :checked="ites.isconts" @click="chiscont(index7,ites,item)" name id />
                            <span class="sz14" v-if="ites.groupCode !== 'concern001' && ites.groupCode !== 'cooperate001' && ites.id!== follid">{{ites.groupName}}</span> -->
                      <div v-if="ites.groupCode != 'cooperate001'">
                        <input
                          type="checkbox"
                          @click="chiscont(index7, ites, item)"
                          name
                          id
                        />
                        <span class="sz14">{{ ites.groupName }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="!follListTwo.length" class="addfo mb20">
                  {{ lmkname }}暂无可添加的分组,请先新建新的分组
                </div>
                <div class="name_butt flex">
                  <div
                    class="center ru5 ba6e coff cursor mr8"
                    v-if="follListTwo.length"
                    @click="preservation"
                  >
                    保存
                  </div>
                  <div
                    class="center ru5 baff butt2 cursor co00"
                    @click="ceartflo"
                  >
                    取消
                  </div>
                </div>
              </div>
            </el-dialog>
          </div>

          <div class="pages" v-if="total > 0">
            <Pagination
              :pageNo="currentPage"
              :pageSize="size"
              :total="total"
              :continues="4"
              @getPageNo="currentChangeTwo"
            />
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="30%"
      top="15%"
      :before-close="handleClose"
    >
      <div>
        <div class="dialog_title sz18 font_bo">新建分组</div>

        <div class="dialog_input flex">
          <p class="sz12 dialog_pt">
            *分组命名中不支持输入符号，只能输入汉字、字母和数字。
          </p>
          <p class="p1">名称</p>
          <p>
            <el-input
              style="width: 100%"
              type="text"
              placeholder="请输入分组名称"
              oninput="value=value.replace(/[^\u4E00-\u9FA5A-Za-z0-9、]/g,'')"
              v-model="groupName"
              maxlength="15"
              show-word-limit
            ></el-input>
          </p>
        </div>
        <div class="butt flex">
          <div class="center ru5 coff ba6e cursor" @click="addfloll">确定</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="dialogVisibledetel"
      width="20%"
      top="15%"
      :show-close="false"
    >
      <div>
        <div class="dialog_del font_bo center co00">你确定吗？</div>
        <div class="dialog_dels center">一旦删除分组，你将无法撤销操作</div>
        <div class="butt flex">
          <div class="center ru5 coff ba6e cursor" @click="delfloll">确定</div>
          <div
            class="center ru5 co00 baff cursor cancel"
            @click="dialogVisibledetel = false"
          >
            取消
          </div>
        </div>
      </div>
    </el-dialog>
    <div class="addfods" v-if="addfods">
      <div class="addfodscenter baff">
        <div class="addfods_icon">
          <i class="el-icon-close cursor co6e" @click="addfods = false"></i>
        </div>
        <div>您已添加联盟客到“所有合作联盟客”分组里面</div>
        <div class="see center">
          请前往<span class="cursor" @click="seeflo">查看</span>
        </div>
      </div>
    </div>

    <el-dialog
      custom-class="dialog_con"
      title="提示"
      :visible.sync="BatchSendConfirmModal"
      width="30%"
    >
      <div>
        <p style="margin-bottom: 15px">您选中的联盟客中：</p>
        <ul style="list-style: inside; padding-left: 15px">
          <li style="list-style: disc; margin-bottom: 5px">
            {{ sendData.hasEmailCount }} 位有邮箱信息可以建联；
          </li>
          <li style="list-style: disc; margin-bottom: 5px">
            其中
            {{ sendData.tooFrequentCount }}
            位已经在过去7天内发送过邮件，本次将不再发送；
          </li>
          <li style="list-style: disc; margin-bottom: 5px">
            {{ sendData.noEmailCount }} 位暂无邮箱无法建联。
          </li>
        </ul>
        <p style="margin-bottom: 20px">
          点击确认后，系统将为您发送邮件给
          {{ sendData.hasEmailCount - sendData.tooFrequentCount }}
          位有邮箱的联盟客。
        </p>
        <p>
          注：为避免打扰，系统将限制发送给同一联盟客的邮件数量为每 7 天 1 封。
        </p>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="BatchSendConfirmModal = false">取 消</el-button>
        <el-button
          v-if="sendData.hasEmailCount - sendData.tooFrequentCount > 0"
          type="primary"
          @click="batchSend"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  QUERYUSERGROUP,
  CREATEGROUP,
  DELGROUP,
  UPDATEGROUP,
  QUERYGROUPDETAILLIST,
  QUERYALLBIGSMALLINDUSTRY,
  QUERYSELECTLIST,
  JOINGROUP,
  REMOVEGROUPDETAIL,
  REMOVEGROUPONEDETAIL,
  QUERYHASGROUP,
} from "../../api/foll";
import { QUERY, CHECKBATCHSENDEMAIL } from "../../api/emial";
export default {
  data() {
    return {
      name: "", // 联盟客姓名
      values: "",
      isRead: "",
      startDate: "", // 开始时间
      endDate: "", // 结束时间
      chooseAll: false, // 全选
      chooseAlltwo: false,
      currentPage: 1, // 分页页数
      size: 10, // 分页条数
      total: 0, // 分页总条数
      follList: [], // 分组列表1
      follListtwo: [], // 分组列表2
      follListsher: [], // 分组列表3
      conlist: [], // 勾选列表
      ast: ["s1", "s2", "s3", "s4", "s5", "s6", "s7", "s8", "s9"], //分组人数字体颜色
      dialogVisible: false, // 新建分组弹窗
      foolcen: 0, // 分组列表选中效果
      groupName: "", // 新增分组名称
      isgroupName: "", //修改分组名称
      dialogVisibledetel: false, //确定删除弹窗
      id: "", //分组id
      liststuts: false, // 更多分组
      detailList: [], //
      groupCode: "", // 分组code
      smallIndustry: [], //类别列表
      countryList: [], // 国家列表
      industrys: "", // 类别
      country: "", // 国家
      isCooperate: "", //是否合作
      isContact: "", //  是否联系
      titname: "", // 分组名称
      detaillist: [], //选中的数据
      detcont: [], //加入分组选中的数据
      nameList: [], // 全选名称
      codeList: [], // 全选code
      currentClickNumber: 0,
      follname: "", // 分组名搜索
      follid: "",
      addfods: false,
      headSrcsList: [],
      comsds: false,
      follListTwo: [],
      dialogaddfoll: false, // 对话框
      allianceCode: "", // 联盟客id
      lmkname: "",
      validParam: localStorage.getItem("validParam"),

      choosedAllIdList: [], //多选可分页id集合
      choosedAllNameList: [], //多选可分页name集合
      choosedAllCodeList: [], //多选可分页code集合
      allChoosedList: [], //多选可分页集合
      BatchSendConfirmModal: false, //批量发送确认弹窗
      sendData: {},
    };
  },
  computed: {
    hasEmailChooseName() {
      let arr = [];
      this.allChoosedList.map((item) => {
        if (item.hasEmail == 1) {
          this.choosedAllNameList.forEach((item2) => {
            if (item2 == item.name) {
              arr.push(item.name);
            }
          });
        }
      });
      return arr;
    },
    hasEmailChooseCode() {
      let arr = [];
      this.allChoosedList.map((item) => {
        if (item.hasEmail == 1) {
          this.choosedAllCodeList.forEach((item2) => {
            if (item2 == item.allianceCode) {
              arr.push(item.allianceCode);
            }
          });
        }
      });
      return arr;
    },
  },

  created() {
    if (this.validParam !== "fl") {
      this.$bus.$emit("showNopermiss", true);
    }
    this.choosedAllIdList = [];
    this.choosedAllNameList = [];
    this.choosedAllCodeList = [];
    this.querylsi();
    this.queryUserGroup();
    this.queryAllBigSmallIndustry();
    this.permitsList();
  },
  mounted() {},
  methods: {
    functionName(e) {},
    // 获取登录信息
    querylsi() {
      QUERY().then((res) => {
        if (res.data.code == "nolog") {
          this.$router.push("./");
        } else if (res.data.code == "forceout") {
          // this.$message({
          //   message: '账号在其他地方登录,您被迫下线',
          //   type: 'warning'
          // });
          localStorage.removeItem("token");
        }
      });
    },
    stopAn() {},
    leaveAn() {},
    // 分组-查询用户下全部分组
    queryUserGroup() {
      QUERYUSERGROUP().then((res) => {
        this.titname = res.data.body[0].groupName;
        if (!this.groupCode) {
          this.groupCode = res.data.body[0].groupCode;
        }
        this.follList = [];
        this.follListtwo = [];
        let arr = res.data.body;
        this.follListsher = res.data.body;
        arr.map((item) => {
          this.follList.push(Object.assign({}, item, { isname: true }));
          this.follListtwo.push(Object.assign({}, item, { isname: true }));
        });
        // this.conlist = []
        // let arr1 = res.data.body
        // arr1.map(item => {
        //   this.conlist.push(Object.assign({}, item, { isconts: false }))
        // })
        this.follList.map((item, index) => {
          if (item.headSrcs) {
            item.headSrcs = item.headSrcs.split(",");
          }
        });
        this.follListtwo.map((item, index) => {
          if (item.headSrcs) {
            item.headSrcs = item.headSrcs.split(",");
          }
        });
        let data = {
          groupCode: this.groupCode,
          size: this.size,
          currentPage: this.currentPage,
        };
        QUERYGROUPDETAILLIST(data).then((res) => {
          if (res.data.code == "success") {
            this.total = res.data.body.total;
            this.allChoosedList = this.detailList.concat(res.data.body.records);
            this.detailList = [];
            let arr = res.data.body.records;
            arr.map((item) => {
              this.detailList.push(Object.assign({}, item, { choose: false }));
            });
            this.detailList.map((item, index) => {
              if (item.myGroupNames) {
                item.myGroupNames = item.myGroupNames.split(",");
              }
              if (item.types) {
                item.types = item.types.split(",");
              }
              if (item.affiliateNetworks) {
                item.affiliateNetworks = item.affiliateNetworks.split(",");
              }
              if (item.promoType) {
                item.promoType = item.promoType.split(",");
              }
              if (item.brands) {
                item.brands = item.brands.split(",");
              }
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    fuzzyQuery() {
      // const reg = new RegExp(this.follname);  //输入关键字
      // const data = ['steven', 'mike', 'alice']
      let arr = [];
      for (let i = 0; i < this.follListtwo.length; i++) {
        if (this.follListtwo[i].groupName.match(this.follname) != null) {
          // this.follList = this.follListtwo[i]
          arr.push(this.follListtwo[i]);
        }
      }
      this.follList = arr;
    },
    // 分组人员信息
    queryGroupDetailList() {
      let data = {
        groupCode: this.groupCode,
        size: this.size,
        currentPage: this.currentPage,
        name: this.name,
        industrys: this.industrys,
        country: this.country,
        startDate: this.startDate,
        endDate: this.endDate,
        isCooperate: this.isCooperate,
        isContact: this.isContact,
      };
      QUERYGROUPDETAILLIST(data).then((res) => {
        if (res.data.code == "success") {
          this.loading = false;
          this.total = res.data.body.total;
          this.allChoosedList = this.detailList.concat(res.data.body.records);
          this.detailList = [];
          let arr = res.data.body.records;
          arr.map((item) => {
            // 改造
            if (this.choosedAllIdList.indexOf(item.id) > -1) {
              this.detailList.push(Object.assign({}, item, { choose: true }));
            } else {
              this.detailList.push(Object.assign({}, item, { choose: false }));
            }
          });
          this.detailList.map((item, index) => {
            if (item.myGroupNames) {
              item.myGroupNames = item.myGroupNames.split(",");
            }
            if (item.types) {
              item.types = item.types.split(",");
            }
            if (item.affiliateNetworks) {
              item.affiliateNetworks = item.affiliateNetworks.split(",");
            }
            if (item.promoType) {
              item.promoType = item.promoType.split(",");
            }
            if (item.brands) {
              item.brands = item.brands.split(",");
            }
          });
          if (this.detailList.length > 0) {
            this.chooseAll = this.detailList.every((item) => {
              return item.choose;
            });
          }
        } else {
          this.$message.error(res.data.msg);
          this.loading = false;
        }
      });
    },
    // 分组-获取(行业/类别)下拉列表数据
    queryAllBigSmallIndustry() {
      QUERYALLBIGSMALLINDUSTRY().then((res) => {
        this.smallIndustry = res.data.body;
      });
    },
    // 获取国家
    permitsList() {
      QUERYSELECTLIST().then((res) => {
        this.countryList = res.data.body.countryAllList;
      });
    },
    // 清空是否已读
    delValue() {
      this.isRead = "";
      // this.queryEmailSendList()
    },
    // 格式化开始时间
    startDa(e) {
      if (e === null) {
        this.startDate = e;
        this.endDate = e;
      } else {
        this.startDate =
          e[0].getFullYear() +
          "-" +
          (e[0].getMonth() + 1) +
          "-" +
          e[0].getDate();
        this.endDate =
          e[1].getFullYear() +
          "-" +
          (e[1].getMonth() + 1) +
          "-" +
          e[1].getDate();
      }
    },
    // 模糊查询
    searchs() {
      this.queryGroupDetailList();
    },
    //分页功能
    currentChangeTwo(val) {
      let arrtemp = this.choosedAllIdList.concat(this.detaillist);
      this.choosedAllIdList = [...new Set(arrtemp)];
      let arrtemp2 = this.choosedAllNameList.concat(this.nameList);
      this.choosedAllNameList = [...new Set(arrtemp2)];
      let arrtemp3 = this.choosedAllCodeList.concat(this.codeList);
      this.choosedAllCodeList = [...new Set(arrtemp3)];
      this.detaillist = [];
      this.nameList = [];
      this.codeList = [];
      this.chooseAll = false;
      this.currentPage = val;
      this.queryGroupDetailList();
    },
    // 关闭新增分组弹窗
    handleClose() {
      this.dialogVisible = false;
    },
    // 分组选中效果
    conclick(e, index) {
      this.currentPage = 1;
      this.follid = e.id;
      this.foolcen = index;
      this.groupCode = e.groupCode;
      this.titname = e.groupName;
      this.queryGroupDetailList();
    },
    seeflo() {
      this.foolcen = 1;
      this.loading = true;
      this.addfods = false;
      this.titname = "所有合作";
      let data = {
        groupCode: "cooperate001",
        size: this.size,
        currentPage: this.currentPage,
        name: this.name,
        industrys: this.industrys,
        country: this.country,
        startDate: this.startDate,
        endDate: this.endDate,
        isCooperate: this.isCooperate,
        isContact: this.isContact,
      };
      QUERYGROUPDETAILLIST(data).then((res) => {
        if (res.data.code == "success") {
          this.loading = false;
          this.total = res.data.body.total;
          this.detailList = [];
          let arr = res.data.body.records;
          arr.map((item) => {
            this.detailList.push(Object.assign({}, item, { choose: false }));
          });
          this.detailList.map((item, index) => {
            if (item.myGroupNames) {
              item.myGroupNames = item.myGroupNames.split(",");
            }
            if (item.types) {
              item.types = item.types.split(",");
            }
            if (item.affiliateNetworks) {
              item.affiliateNetworks = item.affiliateNetworks.split(",");
            }
            if (item.promoType) {
              item.promoType = item.promoType.split(",");
            }
            if (item.brands) {
              item.brands = item.brands.split(",");
            }
          });
        } else {
          this.$message.error(res.data.msg);
          this.loading = false;
        }
      });
    },
    // 新建分组
    addfloll() {
      if (!this.groupName) {
        this.$message.warning("请输入分组名称");
        return;
      }
      CREATEGROUP({ groupName: this.groupName }).then((res) => {
        if (res.data.code == "success") {
          this.$message({
            message: "新建成功",
            type: "success",
          });
          this.groupName = "";
          this.queryUserGroup();
          this.dialogVisible = false;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //删除分组
    delfolls(e) {
      this.id = e;
      this.dialogVisibledetel = true;
    },
    // 修改分组名称
    nameclick(item) {
      this.id = item.id;
      item.isname = !item.isname;
    },
    // input失焦事件 失去焦点触发
    changename(item) {
      if (!this.isgroupName) {
        item.isname = true;
      } else {
        UPDATEGROUP({ groupName: this.isgroupName, id: this.id }).then(
          (res) => {
            if (res.data.code == "success") {
              this.queryUserGroup();
              this.isgroupName = "";
              item.isname = true;
            } else {
              this.$message.error(res.data.msg);
            }
          }
        );
      }
    },
    //delfloll()确定删除
    delfloll() {
      DELGROUP({ id: this.id }).then((res) => {
        if (res.data.code == "success") {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.queryUserGroup();
          this.dialogVisibledetel = false;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 全选按钮
    chooseAllCart() {
      this.detaillist = [];
      this.nameList = [];
      this.codeList = [];
      this.chooseAll = !this.chooseAll;

      // 表中的每一项同步状态
      for (var i = 0; i < this.detailList.length; i++) {
        this.detailList[i].choose = this.chooseAll;
      }
      this.detailList.forEach((item) => {
        if (item.choose) {
          this.detaillist.push(item.id);
          this.nameList.push(item.name);
          this.codeList.push(item.allianceCode);
        } else {
          let index2 = this.detaillist.indexOf(item.id);
          let index3 = this.choosedAllIdList.indexOf(item.id);
          let index4 = this.nameList.indexOf(item.name);
          let index5 = this.choosedAllNameList.indexOf(item.name);
          let index6 = this.codeList.indexOf(item.allianceCode);
          let index7 = this.choosedAllCodeList.indexOf(item.allianceCode);
          if (index2 > -1) {
            this.detaillist.splice(index2, 1);
          }
          if (index3 > -1) {
            this.choosedAllIdList.splice(index3, 1);
          }
          if (index4 > -1) {
            this.nameList.splice(index4, 1);
          }
          if (index5 > -1) {
            this.choosedAllNameList.splice(index5, 1);
          }
          if (index6 > -1) {
            this.codeList.splice(index6, 1);
          }
          if (index7 > -1) {
            this.choosedAllCodeList.splice(index7, 1);
          }
        }
      });

      let arrtemp = this.choosedAllIdList.concat(this.detaillist);
      this.choosedAllIdList = [...new Set(arrtemp)];
      let arrtemp2 = this.choosedAllNameList.concat(this.nameList);
      this.choosedAllNameList = [...new Set(arrtemp2)];
      let arrtemp3 = this.choosedAllCodeList.concat(this.codeList);
      this.choosedAllCodeList = [...new Set(arrtemp3)];
    },
    // 多选按钮
    chooseOne(index, e) {
      // 改造
      this.detailList[index].choose = !this.detailList[index].choose;
      let isCheckedAll = this.detailList.every((item) => {
        return item.choose;
      });
      this.chooseAll = isCheckedAll;
      this.detaillist = [];
      this.nameList = [];
      this.codeList = [];
      this.detailList.forEach((item) => {
        if (item.choose) {
          this.detaillist.push(item.id);
          this.nameList.push(item.name);
          this.codeList.push(item.allianceCode);
        } else {
          let index2 = this.detaillist.indexOf(item.id);
          let index3 = this.choosedAllIdList.indexOf(item.id);
          let index4 = this.nameList.indexOf(item.name);
          let index5 = this.choosedAllNameList.indexOf(item.name);
          let index6 = this.codeList.indexOf(item.allianceCode);
          let index7 = this.choosedAllCodeList.indexOf(item.allianceCode);
          if (index2 > -1) {
            this.detaillist.splice(index2, 1);
          }
          if (index3 > -1) {
            this.choosedAllIdList.splice(index3, 1);
          }
          if (index4 > -1) {
            this.nameList.splice(index4, 1);
          }
          if (index5 > -1) {
            this.choosedAllNameList.splice(index5, 1);
          }
          if (index6 > -1) {
            this.codeList.splice(index6, 1);
          }
          if (index7 > -1) {
            this.choosedAllCodeList.splice(index7, 1);
          }
        }
      });
      let arrtemp = this.choosedAllIdList.concat(this.detaillist);
      this.choosedAllIdList = [...new Set(arrtemp)];
      let arrtemp2 = this.choosedAllNameList.concat(this.nameList);
      this.choosedAllNameList = [...new Set(arrtemp2)];
      let arrtemp3 = this.choosedAllCodeList.concat(this.codeList);
      this.choosedAllCodeList = [...new Set(arrtemp3)];
    },
    // 加入分组多选按钮
    chiscont(index, e, v) {
      if (this.follid === e.id) {
        // return
      } else {
        this.follListTwo[index].isconts = !this.follListTwo[index].isconts;
        for (var i = 0; i < this.follListTwo.length; i++) {
          if (this.follListTwo[i].isconts == false) {
            this.chooseAlltwo = false;
            break;
          }
        }
        if (i == this.detailList.length) {
          this.chooseAlltwo = true;
        }
        if (e.isconts == true) {
          this.detcont.push({
            groupCode: e.groupCode,
            allianceCode: this.allianceCode,
          });
        } else {
          this.detcont.splice(i, 1);
        }
      }
    },
    // 加入分组保存
    preservation() {
      if (!this.detcont.length) {
        this.$message.warning("请先选择");
        return;
      }
      JOINGROUP({
        userGroups: this.detcont,
      }).then((res) => {
        if (res.data.code == "success") {
          this.dialogaddfoll = false;
          this.$message({
            message: "添加成功",
            type: "success",
          });
          setTimeout(() => {
            this.queryUserGroup();
            this.follListTwo = [];
            this.detcont = [];
            this.addflows();
          }, 500);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    ceartflo() {
      this.dialogaddfoll = false;
      var that = this;
      var t;
      clearTimeout(t);
      t = setTimeout(function () {
        // window.eventHub.$emit('refreshList', '')// 更新右侧列表状态
        this.follListTwo = [];
      }, 1000);
    },
    // 批量发送
    batch() {
      if (!this.choosedAllNameList.length) {
        this.$message.warning("请先选择");
        return;
      }
      CHECKBATCHSENDEMAIL({ allianceCodes: this.choosedAllCodeList }).then(
        (res) => {
          if (res.data.code === "success") {
            this.sendData = res.data.body;
          }
        }
      );
      this.BatchSendConfirmModal = true;
    },
    batchSend() {
      // let name = this.hasEmailChooseName.toString();
      // let code = this.hasEmailChooseCode.toString();
      let name1 = this.sendData.sendAlliances.map((item) => item.name);
      let code1 = this.sendData.sendAlliances.map((item) => item.allianceCode);
      let name = name1.toString();
      let code = code1.toString();

      this.$router.push({
        path: "emailConnection",
        query: { allianceCode: code, name: name },
      });
      let routeUrl = this.$router.resolve({
        path: "emailConnection",
        query: { allianceCode: code, name: name },
      });
      this.resetChoosed();
      this.BatchSendConfirmModal = false;
      // window.open(routeUrl.href);
      localStorage.setItem("isSelect", 3);
    },
    // 发送邮件
    sendOut(e) {
      if (e.hasEmail == 1) {
        CHECKBATCHSENDEMAIL({ allianceCodes: [e.allianceCode] }).then((res) => {
          if (res.data.code === "success") {
            if (res.data.body.sendEmailCount > 0) {
              this.$router.push({
                path: "emailConnection",
                query: { allianceCode: e.allianceCode, name: e.name },
              });

              // let routeUrl = this.$router.resolve({
              //   path: "emailConnection",
              //   query: { allianceCode: e.allianceCode, name: e.name },
              // });
              // window.open(routeUrl.href);
              localStorage.setItem("isSelect", 3);
            } else {
              this.$message.warning(
                "为了避免打扰，且营造一个友好合作环境，系统将限制发送给同一联盟客的邮件数量为每7天1封。您已经在过去的7天内向此合作伙伴发送过电子邮件。请稍后再试。"
              );
            }
          }
        });
      }
    },
    // 移出分组
    delfoll() {
      if (!this.choosedAllIdList.length) {
        this.$message.warning("请先选择");
        return;
      }
      this.$confirm("确定要移除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.deleteEnterprise();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 确定移除
    deleteEnterprise() {
      // let ids = this.detaillist.toString()
      REMOVEGROUPDETAIL({ ids: this.choosedAllIdList }).then((res) => {
        if (res.data.code == "success") {
          this.$message({
            message: "移除成功",
            type: "success",
          });
          this.resetChoosed();
          this.queryUserGroup();
        }
      });
    },
    // 加入到关注分组
    addConcern(e) {
      let userGroups = [
        {
          groupCode: "concern001",
          allianceCode: e.allianceCode,
        },
      ];
      JOINGROUP({ userGroups }).then((res) => {
        if (res.data.code == "success") {
          this.queryUserGroup();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 移除关注分组
    delConcern(e) {
      REMOVEGROUPONEDETAIL({
        groupCode: "concern001",
        allianceCode: e.allianceCode,
      }).then((res) => {
        if (res.data.code == "success") {
          this.queryUserGroup();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 加入合作分组
    addCooperate(e) {
      let userGroups = [
        {
          groupCode: "cooperate001",
          allianceCode: e.allianceCode,
        },
      ];
      JOINGROUP({ userGroups }).then((res) => {
        if (res.data.code == "success") {
          this.queryUserGroup();
          // this.$message({
          //   message: '添加成功',
          //   type: 'success'
          // });
          // this.addfods = true
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    addflows(e) {
      // follListTwo
      // dialogaddfoll
      this.follListTwo = [];
      this.lmkname = e.name;
      this.allianceCode = e.allianceCode;
      QUERYUSERGROUP().then((res) => {
        this.follListsher = res.data.body;
        this.follListsher = this.follListsher.filter((item) => {
          return item.groupCode != "cooperate001";
        });

        QUERYHASGROUP({ allianceCode: e.allianceCode }).then((res) => {
          // if (res.data.body.length === this.follListsher.length) {
          //   this.$message.warning('已添加到所有分组里面,先建立新的分组')
          // } else {
          this.dialogaddfoll = true;
          // this.groupingstuts = true
          let ary02 = res.data.body;
          for (var i = 0; i < this.follListsher.length; i++) {
            for (var j = 0; j < ary02.length; j++) {
              if (this.follListsher[i].groupCode == ary02[j]) {
                this.follListsher[i] = "";
                break;
              }
            }
          }
          let arr1 = [];
          for (var i = 0; i < this.follListsher.length; i++) {
            if (this.follListsher[i] != "") {
              arr1.push(this.follListsher[i]);
            }
          }
          this.$nextTick(() => {
            arr1.map((item) => {
              this.follListTwo.push(
                Object.assign({}, item, { isconts: false })
              );
            });
          });
          this.follListTwo.forEach((item, index, array) => {
            if (item.groupCode == "cooperate001") {
              return array.splice(index, 1);
            }
          });
          // }
        });
      });
    },
    // 移除合作分组
    delCooperate(e) {
      REMOVEGROUPONEDETAIL({
        groupCode: "cooperate001",
        allianceCode: e.allianceCode,
      }).then((res) => {
        if (res.data.code == "success") {
          this.queryUserGroup();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 查看详情
    godetil(e) {
      let routeUrl = this.$router.resolve({
        path: "details",
        query: { code: e.allianceCode },
      });
      window.open(routeUrl.href, "_blank");
    },

    // 重置勾选数据
    resetChoosed() {
      // 重置
      this.allChoosedList = this.detailList;
      this.choosedAllIdList = [];
      this.choosedAllNameList = [];
      this.choosedAllCodeList = [];
      this.detaillist = [];
      this.nameList = [];
      this.codeList = [];
      this.detailList.forEach((item) => {
        item.choose = false;
      });
      this.chooseAll = false;
    },
  },
  beforeDestroy() {},
};
</script>
<style lang="less" scoped>
::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

.category_butt {
  background: rgba(168, 168, 191, 0.25);
}

.banone {
  background: none;
}

.pd23 {
  padding-top: 23px;
}

.yesemil {
  background: #be3c6e;
  color: #fff;
  cursor: pointer;
}

.noemail {
  color: #000;
  background: #404040;
  opacity: 0.5;
  cursor: not-allowed;
}

.titnames {
  width: 90px;
}

.borderrig {
  border-right: 1px solid #d5d5d5;
}

.s1 {
  color: #9577e5;
}

.s2 {
  color: #2cd4d3;
}

.s3 {
  color: #ddb2f9;
}

.s4 {
  color: #f89589;
}

.s5 {
  color: #fec776;
}

.s6 {
  color: #fc6780;
}

.s7 {
  color: #7892ec;
}

.s8 {
  color: #b28c68;
}

.s9 {
  color: #707070;
}

div {
  box-sizing: border-box;
}

.ba {
  background: #d8dee8;
}

.foll_titles {
  width: 240px;
  overflow: hidden;
  /*超出的部分隐藏起来。*/
  white-space: nowrap;
  /*不让文本换行,在一行显示*/
  position: relative;
  background: #fafafd;

  p {
    height: 25px;
    line-height: 25px;
    background: #bde3e6;
    padding: 0 10px;
    margin-right: 5px;
  }

  .kkk {
    display: flex;
    align-items: center;
    position: relative;
    margin: 0;

    &:hover {
      animation-name: move;
      /*动画名称*/
      animation-duration: 25s;
      animation-fill-mode: forwards;
    }
  }

  .jjj {
    display: flex;
    align-items: center;
    position: relative;
    margin: 0;

    &:hover {
      animation-name: moves;
      /*动画名称*/
      animation-duration: 10s;
      animation-fill-mode: forwards;
    }
  }
}

@keyframes moves {
  from {
    transform: translate(0, 0);
  }

  to {
    transform: translate(-90%, 0);
  }
}

.foll_title {
  width: 300px;
  overflow: hidden;
  /*超出的部分隐藏起来。*/
  white-space: nowrap;
  /*不让文本换行,在一行显示*/
  position: relative;
  background: #fafafd;

  p {
    height: 25px;
    line-height: 25px;
    // background: #bde3e6;
    padding: 0 10px;
    margin-right: 5px;
  }

  .kkk {
    display: flex;
    align-items: center;
    position: relative;
    margin: 0;

    &:hover {
      animation-name: move;
      /*动画名称*/
      animation-duration: 25s;
      animation-fill-mode: forwards;
    }
  }
}

.category_div {
  width: 300px;
  overflow: hidden;
  position: relative;

  .kkk {
    display: flex;
    align-items: center;
    position: relative;
    margin: 0;

    &:hover {
      animation-name: move;
      /*动画名称*/
      animation-duration: 25s;
      animation-fill-mode: forwards;
    }
  }

  .category_butt {
    // min-width: 80px;
    padding: 0 10px;
    height: 25px;
    line-height: 25px;
    // background: #d8dee8;
    margin-right: 5px;
    flex-shrink: 0;
    // &:first-child {
    //   margin: 0;
    // }
  }
}

@keyframes move {
  from {
    transform: translate(0, 0);
  }

  to {
    transform: translate(-90%, 0);
  }
}

// .category_div:hover {
//   margin-right: 50px;
// }
.H22 {
  height: 22px;
}

.h25 {
  height: 25px;
  line-height: 25px;
}

.addfo {
  // width: 520px;
  // height: 360px;
  padding: 27px 0 0 36px;

  .nametit {
    width: 100%;
    margin-bottom: 28px;
  }

  .naelist_top {
    width: 100%;
    flex-wrap: wrap;
    height: 200px;
    overflow: auto;
    padding: 8px;

    .namelist {
      width: 100%;
      height: 19px;
      align-items: center;
      margin-bottom: 22px;
      width: 50%;

      input {
        width: 19px;
        height: 19px;
        margin-right: 16px;
      }

      input[type="checkbox"] {
        cursor: pointer;
        position: relative;
        width: 19px;
        height: 19px;
        line-height: 19px;
        font-size: 18px;
      }

      input[type="checkbox"]::after {
        position: absolute;
        top: 0;
        color: #000;
        width: 19px;
        height: 19px;
        display: inline-block;
        visibility: visible;
        padding-left: 0px;
        text-align: center;
        content: " ";
        border-radius: 3px;
      }

      input[type="checkbox"]:checked::after {
        content: "✔";
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        background-color: #be3c6e;
      }
    }
  }

  .naelist_top::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    background: #a6a8bf;
  }

  .naelist_top::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    border-radius: 10px;
    background: #ededed;
  }

  .naelist_top::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
}

.name_butt {
  width: 100%;
  justify-content: center;
  margin-bottom: 12px;

  div {
    width: 110px;
    height: 40px;
    line-height: 40px;
  }

  .mr8 {
    margin-right: 10px;
  }

  .butt2 {
    border: 1px solid #be3c6e;
  }
}

@media screen and (min-width: 1000px) and (max-width: 2000px) {
  .top_center {
    width: 1600px;
    // margin: 0 auto;
  }
}

@media screen and (min-width: 2000px) and (max-width: 3000px) {
  .top_center {
    width: 1920px;
    // margin: 0 auto;
  }
}

.inbox {
  padding-top: 30px;
  width: 100%;
  height: 100%;
  min-height: 90vh;
  box-sizing: border-box;
  background: #fafafd;
  position: relative;

  .addfods {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.2);
    position: fixed;
    top: 0;
    left: 0;

    .addfodscenter {
      // width: 380px;
      height: 195px;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -97px;
      margin-left: -180px;
      padding: 53px 29px 53px 29px;
      font-size: 14px;

      .addfods_icon {
        position: absolute;
        right: 10px;
        top: 10px;
      }

      .see {
        width: 100%;
        margin-top: 50px;
      }

      span {
        text-decoration: underline #be3c6e;
      }
    }
  }

  .top_center {
    .follow {
      width: 100%;
      min-width: 970px;
      margin: 0 auto;
      box-sizing: border-box;
      // padding-top: 23px;
    }

    .follow_left_center {
      width: 250px;
      position: relative;
      // left: 0;
    }

    .follow_left {
      width: 235px;
      height: 80vh;
      min-height: 600px;
      padding-top: 23px;
      box-shadow: 0px 0px 20px 1px rgba(0, 0, 0, 0.05);
      box-sizing: border-box;
      background: #f8f8f8;
      border: 1px solid #d5d5d5;
      overflow-y: scroll;

      .addfoll {
        width: 80%;
        height: 42px;
        margin: 0 auto;
        margin-bottom: 23px;
        line-height: 42px;
      }

      .foll_name {
        border-bottom: 1px solid rgba(173, 175, 196, 0.5);
        // padding: 0 8px;
        padding-bottom: 15px;

        .foll_center {
          width: 80%;
          margin: 0 auto;
          align-items: center;
        }

        div {
          padding-right: 5px;
        }
      }

      .foll_list {
        width: 100%;
        box-sizing: border-box;
        margin-top: 10px;

        .foll_list_top {
          width: 100%;
          height: 100%;
          padding: 0 5px;
          background: #f8f8f8;
          overflow: auto;
        }

        .foll_list_top::-webkit-scrollbar-thumb {
          /*滚动条里面小方块*/
          border-radius: 10px;
          background: #a6a8bf;
        }

        .foll_list_top::-webkit-scrollbar-track {
          /*滚动条里面轨道*/
          border-radius: 10px;
          background: #ededed;
        }

        .foll_list_top::-webkit-scrollbar {
          /*滚动条整体样式*/
          width: 2px;
          /*高宽分别对应横竖滚动条的尺寸*/
          height: 1px;
        }

        .zufz {
          width: 100%;
          height: 50px;
          line-height: 50px;
          text-align: center;
          background: #fff;
        }

        .list_top2 {
          overflow-y: scroll;
        }

        .more {
          width: 100%;
          height: 38px;
          margin: 15px 0;

          div {
            width: 126px;
            height: 100%;
            line-height: 38px;
            margin: 0 auto;
          }
        }

        .list_conent {
          width: 100%;
          background: #fff;
          padding-left: 5px;
          padding-top: 13px;
          padding-bottom: 13px;
          margin-bottom: 20px;
          box-sizing: border-box;
          box-shadow: 0px 0px 20px 1px rgba(0, 0, 0, 0.05);

          // box-shadow: 6px 6px 54px 1px rgba(0, 0, 0, 0.05);
          .list_conent_top {
            width: 100%;
            height: 40px;
            line-height: 40px;

            .titles {
              width: 55%;

              P {
                overflow: hidden;
                /*超出的部分隐藏起来。*/
                white-space: nowrap;
                /*不让文本换行,在一行显示*/
                text-overflow: ellipsis;
                /*超出显示...*/
              }
            }

            .list_conent_top_img {
              width: 45%;
              text-align: right;
              padding-right: 8px;

              .iconimg {
                margin-right: 10px;
                font-size: 17px;
              }

              .icondelete {
                color: #f56c6c;
              }

              img {
                width: 18px;
                height: 18px;
                margin: 0 3px;
              }
            }
          }

          .mannum {
            width: 100%;
            font-size: 28px;
            margin: 9px 0 9px 0;
          }

          .head_img {
            width: 100%;

            img {
              width: 47px;
              // height: 30px;
              border-radius: 50%;
              margin-right: 16px;
            }
          }
        }

        .conentcor {
          background: #e9e9ef;
        }
      }
    }

    .conter_content {
      width: calc(100% - 250px);
      min-width: 840px;
      box-sizing: border-box;
      margin: 0 auto;
      padding-left: 20px;
      padding-bottom: 80px;
      overflow-x: hidden;

      .title_top {
        // padding-top: 25px;
        .title {
          height: 56px;
          border-radius: 5px;

          .input_tt {
            color: #171717;
            width: 75px;

            img {
              width: 34px;
              height: 30px;
            }
          }

          .input_t2 {
            color: #171717;
            width: 120px;

            img {
              width: 34px;
              height: 30px;
            }
          }

          .input_ttw {
            width: 75px;
            color: #171717;
          }

          div {
            height: 100%;
          }

          .title_input {
            width: 300px;
            height: 54px;
            border: 1px solid #d5d5d5;
            border-radius: 5px;
            position: relative;

            .icons {
              width: 16px;
              height: 46px;
              position: absolute;
              right: 10px;
              top: 0;
              display: flex;
              align-items: center;

              img {
                width: 16px;
                height: 16px;
              }
            }
          }

          .title_ks {
            // width: 500px;
            border: 1px solid #d5d5d5;
            position: relative;
            border-radius: 5px;

            img {
              width: 34px;
              height: 30px;
              position: absolute;
              left: 30px;
              top: 50%;
              margin-top: -15px;
            }
          }

          .title_scslt {
            // width: 298px;
            border: 1px solid #d5d5d5;
            border-radius: 5px;
          }
        }

        .title_qu {
          height: 56px;
          display: flex;
          align-items: center;
          padding-left: 24px;

          .title_query {
            width: 130px;
            height: 40px;
            font-size: 16px;
            line-height: 40px;
          }
        }
      }

      .list_top {
        margin-top: 20px;
        width: 100%;
        height: 48px;
        padding: 0 20px 0 10px;
        box-sizing: border-box;
        margin-bottom: 20px;

        div {
          flex: 1;
          height: 100%;
          line-height: 48px;
        }

        .list_top1 {
          text-align: left;
          align-items: center;

          p {
            display: flex;
            align-items: center;
          }

          input {
            width: 28px;
            height: 28px;
          }

          span {
            display: inline-block;
            margin-left: 16px;
            // text-decoration: underline #be3c6e;
          }
        }

        .list_top2 {
          text-align: center;
        }

        .list_top3 {
          text-align: right;

          p {
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: end;
          }

          span {
            display: inline-block;

            i {
              font-size: 20px;
            }
          }

          .span1 {
            margin-right: 100px;
          }

          img {
            width: 22px;
            height: 22px;
            margin-right: 6px;
          }
        }
      }

      .list {
        width: 100%;
        height: 170px;
        border-bottom: 1px solid rgba(64, 64, 64, 0.24);
        padding-left: 15px;
        margin-bottom: 30px;

        .list_input {
          height: 100%;
          align-items: center;

          input {
            width: 28px;
            height: 28px;
          }
        }

        .name {
          width: 150px;
          height: 100%;
          margin-left: 30px;

          .name_heder {
            width: 150px;
            height: 150px;
            position: relative;

            .hotbq {
              position: absolute;
              top: -5px;
              left: -20px;
              transform: rotate(-45deg);
              -ms-transform: rotate(-45deg);
              /* Internet Explorer */
              -moz-transform: rotate(-45deg);
              /* Firefox */
              -webkit-transform: rotate(-45deg);
              /* Safari 和 Chrome */
              -o-transform: rotate(-45deg);
              /* Opera */
            }

            img {
              width: 100%;
              height: 100%;
            }

            p {
              width: 150px;
              height: 50px;
              line-height: 50px;
              background: rgba(0, 0, 0, 0.5);
              position: absolute;
              bottom: 0;
            }
          }
        }

        .category {
          margin-left: 30px;
          padding: 20px 0;
          width: 400px;

          .platform_d {
            height: 25px;
          }

          .fz {
            display: flex;
            align-items: center;
            height: 25px;
          }

          div {
            display: flex;

            .category_tt {
              width: 90px;
              min-width: 75px;
              margin-right: 5px;
            }

            .category_name {
              min-width: 120px;
              margin-right: 6px;
              overflow: hidden;
              /*超出的部分隐藏起来。*/
              white-space: nowrap;
              /*不让文本换行,在一行显示*/
              text-overflow: ellipsis;

              /*超出显示...*/
              span {
                display: inline-block;
                margin-right: 10px;
              }
            }
          }
        }

        .platform {
          margin-left: 30px;
          padding: 20px 0;

          .platform_d {
            height: 30px;
            margin-bottom: 5px;
          }

          .platform_tit {
            margin-right: 32px;
          }

          div {
            display: flex;

            // width: 300px;
            .category_tt {
              width: 90px;
              margin-right: 5px;
            }
          }
        }

        .send {
          padding: 20px 0;
          flex: 1;

          .send_img {
            display: flex;
            height: 32px;
            width: 100%;
            justify-content: end;

            img {
              width: 30px;
              height: 28px;
              margin-right: 22px;
            }

            span {
              display: inline-block;
              height: 32px;
              line-height: 32px;
              font-size: 30px;
              font-weight: bold;
            }

            .send_img_img {
              width: 30px;
              // height: 24px;
              // margin-top: 5px;
            }
          }

          .submit_top {
            width: 100%;
            justify-content: end;
            margin-top: 10px;

            .submit {
              width: 130px;
              height: 40px;
              line-height: 40px;
            }
          }
        }
      }
    }
  }
}

.dialog_title {
  width: 100%;
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid rgba(64, 64, 64, 0.24);

  .butt {
    width: 100%;
    justify-items: center;

    div {
      width: 96px;
      height: 40px;
      line-height: 40px;
    }
  }
}

.dialog_input {
  margin: 40px 0 90px 40px;
  position: relative;

  .dialog_pt {
    position: absolute;
    left: -40px;
    top: -40px;
    z-index: 1;
  }

  p {
    height: 40px;
    line-height: 40px;
  }

  .p1 {
    margin-right: 14px;
  }
}

.dialog_del {
  width: 100%;
  font-size: 39px;
}

.dialog_dels {
  width: 100%;
  margin: 36px 0 86px 0;
}

.cancel {
  border: 1px solid #be3c6e;
  margin-left: 60px;
}

.mb8 {
  margin-bottom: 8px;
}

.mb20 {
  margin-bottom: 20px;
}

::v-deep .el-dialog {
  border-radius: 12px !important;
}
</style>
<style lang="less">
// .el-input__inner:hover {
//   border: none;
// }
// .el-input__inner {
//   border: none;
// }
.follows {
  padding-left: 20px;

  .el-input--suffix .el-input__inner {
    height: 100%;
  }

  .el-select {
    width: 100%;
  }

  .el-select > .el-input {
    width: 100%;
    height: 100%;
  }

  .el-pagination .el-select .el-input .el-input__inner {
    background: none;
  }

  .el-pager li {
    background: none;
  }

  .el-pagination button:disabled {
    background: none;
    // color: #be3c6e;
  }

  .el-pager li.active {
    color: #000;
    font-family: "OPPOSans-R";
    src: url("../../assets/ttf/OPPOSans-R.ttf");
  }

  // .el-icon-arrow-up:before {
  //   color: #be3c6e;
  // }
  // .el-range-editor.el-input__inner {
  //   width: 100%;
  //   border: none;
  //   padding-left: 50px;
  // }
  .el-date-editor .el-range-separator {
    height: 100%;
    line-height: 48px;
  }

  .el-icon-date:before {
    color: #be3c6e;
    font-size: 28px;
  }

  .el-date-editor .el-range__icon {
    line-height: 46px;
    margin-right: 5px;
  }

  .el-date-table td.end-date span,
  .el-date-table td.start-date span {
    color: #fff;
    background: #be3c6e;
  }

  .el-drawer__wrapper {
    top: 70px;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: hidden;
    margin: 0;
  }

  .el-pagination__sizes {
    display: none !important;
  }

  .el-pagination__total {
    display: none !important;
  }
}

.drawer_center {
  .el-icon-close:before {
    color: #232323;
  }
}

.templates_top {
  .el-popper[x-placement^="bottom"] {
    width: 206px !important;
  }
}

.inbox {
  .pagination-container {
    background: #fafafd !important;
  }
}

.dialog_input {
  .el-input__inner:hover {
    border: 1px solid #000;
  }

  .el-input__inner {
    border: 1px solid #000;
    width: 400px;
  }
}

.send_img {
  .el-col-12 {
    width: 30px;
  }
}

.foll_name {
  .el-input__inner {
    background: #f8f8f8;
  }
}

.el-icon-date:before {
  display: none !important;
}

.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  color: #000;
  background: #fff;
}

.conter_content {
  .el-input__inner {
    // height: 100%;
  }

  .title_input .el-input__inner {
    border: none;
  }

  .el-input__inner {
    // border: none;
  }

  .el-input--suffix .el-input__inner {
    border: none;
  }

  .el-range-editor.el-input__inner {
    width: 100%;
    border: none;
  }

  // .el-pager li:last-child {
  //   display: none !important;
  // }
}

.pagination-container {
  background: none !important;
}

.el-icon-arrow-up:before {
  content: "";
}

.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.operatebox {
  height: 54px;
  position: relative;
  background-color: #fafafd;

  .lable {
    display: inline-block;
    width: 80px;
    height: 100%;
    line-height: 54px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    img {
      width: 34px;
      height: 30px;
    }
  }

  .value {
    position: absolute;
    display: inline-block;
    height: 54px;
    line-height: 54px;
    width: calc(100% - 85px);
    // border: 1px solid #d5d5d5;
    border-radius: 5px;

    .el-input--suffix .el-input__inner {
      height: 54px;
      border: 1px solid #d5d5d5;
      border-radius: 5px;
    }

    .el-date-editor {
      height: 54px;
      border: 1px solid #d5d5d5;
      border-radius: 5px;
    }

    .el-select {
      width: 100%;
    }

    .el-select > .el-input {
      width: 100%;
      height: 100%;
    }
  }

  .spcilbox {
    position: absolute;
    height: 54px;
    display: inline-block;
    line-height: 54px;
    width: calc(100% - 85px);
    border-radius: 5px;
    // border: 1px solid #d5d5d5 !important;

    .el-input {
      height: 54px;
      border-radius: 5px;

      input {
        height: 100%;
      }
    }
  }

  .btn {
    width: 150px;
    height: 54px;
    line-height: 54px;
    font-size: 16px;
  }
}
</style>
